import {useFormik} from 'formik';
import {useState} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import * as Yup from 'yup';
import {HttpError} from '../../../../common/hooks/ApiClient';
import {routes} from '../../../../routing/routes';
import useShootForgotCode from '../../common/hooks/useShootForgotCode';
import {useI18n} from '../../../../common/providers/I18nProvider';

const useForgot = () => {
	const [loading, setLoading] = useState(false);
	const {shoot} = useShootForgotCode();
	const navigate = useNavigate();
	const location = useLocation();

	const {i18n} = useI18n();

	const forgotSchema = Yup.object().shape({
		email: Yup.string()
			.email(i18n('AUTH.FORGOT.VALIDATION.EMAIL.FORMAT'))
			.min(3, i18n('AUTH.FORGOT.VALIDATION.EMAIL.MIN', {val: 3}))
			.max(50, i18n('AUTH.FORGOT.VALIDATION.EMAIL.MAX', {val: 50}))
			.required(i18n('AUTH.FORGOT.VALIDATION.EMAIL.REQUIRED')),
	});

	const formik = useFormik({
		initialValues: {
			email: undefined,
		},
		validationSchema: forgotSchema,
		onSubmit: async (values, {setStatus, setSubmitting}) => {
			setLoading(true);
			try {
				await shoot(values.email);
				navigate(routes.verifyForgot, {state: {email: values.email, prevUrl: location.pathname}});
			} catch (error) {
				if (error instanceof HttpError) {
					setStatus(error.message);
				}
			} finally {
				setSubmitting(false);
				setLoading(false);
			}
		},
	});

	const isEmailInvalid = formik.touched.email && formik.errors.email !== undefined;

	const canNotSubmit = formik.isSubmitting || !formik.isValid || formik.values.email === undefined;

	return {loading, formik, canNotSubmit, isEmailInvalid};
};

export default useForgot;
